import { ControlledTable } from "Components";
import { SingleFormObjType } from "DataTypes/Form";
import { actionArrType, columnType } from "DataTypes/Table";

export const FormDataObj: SingleFormObjType = {
  id: "practice",
  label: "Problem",
  placeholder: "Select Problem",
  boxType: "single-select",
  boxSize: 3,
  validatetype: "dropdown",
  readOnly: false,
  dropArr: [
    {
      id: 1,
      label: "Asthma",
      value: 1
    }
  ]
};

export const TableCol: () => columnType[] = () => {
  const Arr: columnType[] = [
    ControlledTable.ColumnData.ProblemNameCol("20%"),
    ControlledTable.ColumnData.CreatedByCol("20%"),
    ControlledTable.ColumnData.CreatedAtCol("20%"),
    ControlledTable.ColumnData.StatusCol("20%"),
    ControlledTable.ColumnData.ActionCol(),
  ];
  return Arr;
};

export interface PreApprovTableDataType {
  id: number | null,
  problemName: string,
  createdby: string,
  createdat: string,
  status: string
}

export const TableData: PreApprovTableDataType[] = [
  {
    id: 1,
    problemName: "Asthma",
    createdby: "Emor Admin, PAdmin",
    createdat: "01/06/2026 10:30 AM",
    status: "Active"
  }
]

export const actionArr: (
  handleEditPreApprovedPlan: () => void
) => actionArrType[] = (handleEditPreApprovedPlan) => {
  const Arr: actionArrType[] = [
    ControlledTable.ActionData.editAction({
      handleClick: handleEditPreApprovedPlan
    }),
    ControlledTable.ActionData.enableDisableAction(
      () => console.log("test"), true
    ),
    ControlledTable.ActionData.deleteAction()
  ];
  return Arr;
};

